import { type TableQueryType } from '../store/schema/TableQuery';
import { isFeatureEnabled } from 'owa-feature-flags';
import getCopilotPrioritizeSettings from 'owa-mail-copilot-settings/lib/selectors/getCopilotPrioritizeSettings';
import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import type TableView from '../store/schema/TableView';
import type MailFolderTableQuery from '../store/schema/MailFolderTableQuery';
import type { MailboxInfo } from 'owa-client-types';
import { getItem } from 'owa-local-storage';

type Pivot = 'n/a' | 'all' | 'focused' | 'other' | 'priority' | 'none';

export function getSelectedInboxPivot(tableView: TableView, mailboxInfo: MailboxInfo): Pivot {
    const folderName =
        tableView.tableQuery.type === 0 && folderIdToName(tableView.tableQuery.folderId);
    const focusedViewFilter = (tableView.tableQuery as MailFolderTableQuery).focusedViewFilter;
    const isPriorityFilter =
        (tableView.tableQuery as MailFolderTableQuery).viewFilter === 'CopilotHighPriority';
    const { prioritizationEnabled, experimentalSetting } =
        getCopilotPrioritizeSettings(mailboxInfo);
    const prioritizeTabEnabled =
        isFeatureEnabled('tri-priority-tab-dev2') &&
        prioritizationEnabled &&
        (experimentalSetting == 'true' || experimentalSetting === null);

    let pivot: Pivot = 'n/a';
    if (folderName === 'inbox') {
        switch (focusedViewFilter) {
            case -1: {
                pivot = prioritizeTabEnabled ? (isPriorityFilter ? 'priority' : 'all') : 'none';
                break;
            }
            case 0: {
                pivot = prioritizeTabEnabled && isPriorityFilter ? 'priority' : 'focused';
                break;
            }
            case 1: {
                pivot = 'other';
                break;
            }
        }
    }

    return pivot;
}

// Returns true if the current table is the High Priority filter and the user got
// there via the Prioritize rollup UI. Otherwise, returns false.
export function getPrioritizeRollupClickStatus(tableView: TableView): boolean {
    const isPriorityFilter =
        (tableView.tableQuery as MailFolderTableQuery).viewFilter === 'CopilotHighPriority';

    return isPriorityFilter && getItem(window, 'mail_prioritizeRollupFilter') === 'true';
}
